<template>
  <div class="mt-3">
    <div>
      SPI: <strong>{{ spi }}</strong>
    </div>

    <div class="d-flex w-50 justify-content-between mb-3">
      <fcc-input class="mt-4 mr-3 flex-grow-1" v-model="numeroDoPedido"
        >Digite o número do pedido:</fcc-input
      >
      <div class="align-self-end">
        <fcc-button @click="buscar" :disabled="!numeroDoPedido">Buscar</fcc-button>
      </div>
    </div>

    <b-card class="w-100" v-if="pedido">
      <div v-if="isEmpty(pedido)" class="p-4 text-center">Boleto não gerado</div>

      <div v-else>
        <h4>Instrução de pagamento</h4>
        <div><strong>Data vencimento: </strong>{{ dataVencimento }}</div>
        <div><strong>Linha digitável: </strong>{{ pedido.linhaDigitavel }}</div>
        <div><strong>Status: </strong>{{ pedido.descricaoStatus }}</div>
      </div>
    </b-card>

    <div v-if="pedido && !isEmpty(pedido)" class="w-100">
      <div class="my-3 text-right">
        <fcc-button @click="gerarRealmenteBoleto" v-if="testeBoleto && itemsLogs.length == 0"
          >Gerar Boleto</fcc-button
        >
        <fcc-button @click="testarBoleto">Testar Boleto</fcc-button>
      </div>

      <fcc-table
        :fields="fieldsLogs"
        striped
        hover
        responsive
        :por-page="'100'"
        search
        pagination
        field-visibility
        pdf
        xls
        csv
        title-page="Logs Gerar Boleto"
        title-p-d-f="Logs Gerar Boleto"
        :items="itemsLogs"
      ></fcc-table>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '../../../store'

export default {
  data() {
    return {
      numeroDoPedido: '',
      pedido: null,
      testeBoleto: false,
      logs: [],
      fieldsLogs: [
        { key: 'numeropedido', label: 'Número do Pedido', sortable: true, active: true },
        { key: 'spi', label: 'SPI', sortable: true, active: true },
        { key: 'nmfuncionario', label: 'Nome do Funcionário', sortable: true, active: true }
      ],
      itemsLogs: []
    }
  },
  props: {
    controlePage: Object
  },
  computed: {
    spi() {
      return this.controlePage.spi
    },
    dataVencimento() {
      return new Date(this.pedido?.dataVencimento).toLocaleDateString('pt-BR')
    }
  },
  watch: {
    pedido(value) {
      if (!!value && !this.isEmpty(value)) {
        this.carregaTexto(this.codeMensagem('C01'))
        this.listarLogsGerarBoleto().then(this.carregaTexto)
      }
    }
  },
  methods: {
    isEmpty(obj) {
      return obj && Object.keys(obj).length === 0
    },
    buscar() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          fccStore.state.baseUrlBoleto + 'Boleto/ArquivoCobranca/' + this.numeroDoPedido,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.pedido = response?.data || {}
          if (this.isEmpty(this.pedido)) {
            this.callConfirm('O boleto ainda não foi gerado, deseja gerar?', '').then((result) => {
              if (result.value) {
                this.gerarBoletosCobrancas(true)
              }
            })
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    testarBoleto() {
      this.gerarBoletosCobrancas(false)
    },
    gerarRealmenteBoleto() {
      this.callConfirm('Deseja realmente gerar um novo boleto?', '').then((result) => {
        if (result.value) {
          this.gerarBoletosCobrancas(true)
        }
      })
    },
    gerarBoletosCobrancas(comercioEletronico) {
      const payload = {
        numeroPedido: this.numeroDoPedido,
        idPublicacao: this.controlePage.idpublicacao,
        comercioEletronico: comercioEletronico
      }
      this.testeBoleto = false
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          fccStore.state.baseUrlBoleto + 'Boleto/GerarBoletosCobrancas',
          payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.testeBoleto = true
          if (comercioEletronico) {
            this.callToast('Boleto gerado', 'success')
            this.inserirLogGerarBoleto()
          } else {
            this.callToast('Boleto testado', 'success')
          }
        })
        .then(this.buscar)
        .then(this.listarLogsGerarBoleto)
        .catch(this.setErrorSystem)
        .finally(() => {
          this.carregaTexto()
        })
    },
    inserirLogGerarBoleto() {
      const payload = {
        numeroPedido: this.numeroDoPedido,
        spi: this.spi,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return new Promise((resolve) => {
        axios
          .post(
            fccStore.state.baseUrlPublicacao + 'Publicacao/InserirLogGerarBoleto',
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    listarLogsGerarBoleto() {
      return new Promise((resolve) => {
        axios
          .get(
            fccStore.state.baseUrlPublicacao +
              'Publicacao/ListarLogsGerarBoleto/' +
              this.numeroDoPedido,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.itemsLogs = response.data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    }
  }
}
</script>